import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import arrowLeft from "../assets/images/navbar/arrow-left.png";

// Aligned with mobile App/Data/StaticContent.ts FAQ_DATA
const FAQ_DATA = [
  {
    id: "1",
    question: "How do I place an order?",
    answer:
      "Browse restaurants on the home screen, select items from the menu, add them to your cart, and proceed to checkout. Choose your delivery address and payment method to complete the order.",
  },
  {
    id: "2",
    question: "Can I track my order in real time?",
    answer:
      "Yes. Once your order is confirmed, you can track its status from the Orders tab. You will see updates when the restaurant accepts, prepares, and dispatches your order.",
  },
  {
    id: "3",
    question: "What payment methods are accepted?",
    answer:
      "Dudos supports UPI, credit/debit cards, net banking, and wallet payments. Cash on delivery may be available for select restaurants and locations.",
  },
  {
    id: "4",
    question: "How do refunds work?",
    answer:
      "If your order is cancelled or not delivered, eligible refunds are processed to your original payment method within 5–7 business days. For partial issues, contact Help and Support from your profile.",
  },
  {
    id: "5",
    question: "Can I schedule a delivery?",
    answer:
      "Some restaurants allow scheduled orders. When available, you can pick a delivery slot during checkout before confirming your order.",
  },
  {
    id: "6",
    question: "How do I use coupons and offers?",
    answer:
      "Apply available coupons at checkout or tap on offers shown on a restaurant page. Each offer has specific terms such as minimum order value and validity period.",
  },
];

const FAQs = () => {
  const navigate = useNavigate();
  const [openId, setOpenId] = useState<string | null>("1");

  return (
    <div className="bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300 mt-[7.5rem] md:mt-[72px]">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 flex items-center justify-center"
          >
            <img src={arrowLeft} alt="back" className="w-6 h-6 dark:invert" />
          </button>
          <h1 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold">
            FAQs
          </h1>
        </div>

        <div className="space-y-3">
          {FAQ_DATA.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-[16px] border dark:border-gray-700 bg-white dark:bg-gray-800 overflow-hidden"
              >
                <button
                  className="w-full flex justify-between items-center p-4 text-left"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                >
                  <span className="text-[#050505] dark:text-white font-urbanist text-[16px] font-semibold pr-4">
                    {item.question}
                  </span>
                  <span className="text-[#7402A7] dark:text-purple-400 text-xl">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 pb-4">
                    <p className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[14px] leading-[160%]">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQs;
